import { __awaiter, __generator } from "tslib";
import { fetchFeatureGates, getFeatureGates, } from '@office-start/feature-gates-service';
import { redirectToLogin } from './redirectToLogin';
var ONE_DAY_MS = 1 * 24 * 60 * 60 * 1000; /* 1 day in ms */
var FIVE_MINUTES_MS = 5 * 60 * 1000; /* 5 minutes in ms */
// A limitation of SPA applications is their refresh tokens have a lifetime of 1 day.
// After that, they expire and we need to re-login the user to get a new refresh token.
// See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/token-lifetimes.md for more info.
export function setupSpaTokenRefresh(identity) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var featureGatesResult, gates, _c, issuedTimeMs, timeTillExpiry;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!identity) {
                        return [2 /*return*/];
                    }
                    featureGatesResult = getFeatureGates();
                    if (!(featureGatesResult === null || featureGatesResult === void 0 ? void 0 : featureGatesResult.result)) return [3 /*break*/, 1];
                    _c = featureGatesResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchFeatureGates()];
                case 2:
                    _c = _d.sent();
                    _d.label = 3;
                case 3:
                    gates = _c;
                    if (gates && ((_b = (_a = gates.result) === null || _a === void 0 ? void 0 : _a.authGates) === null || _b === void 0 ? void 0 : _b.authSilentSsoEnabled)) {
                        return [2 /*return*/];
                    }
                    issuedTimeMs = identity.identityIssuedTimeUnixMs || Date.now();
                    timeTillExpiry = ONE_DAY_MS - (Date.now() - issuedTimeMs) - FIVE_MINUTES_MS;
                    window.setTimeout(function () {
                        redirectToLogin(identity, 'SpaTokenExpiry', {
                            IdentityIssuedTime: identity.identityIssuedTimeUnixMs || -1,
                        });
                    }, timeTillExpiry);
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=setupSpaTokenRefresh.js.map